const ENTER_KEY_HINTS = {
  GO: 'go',
  ENTER: 'enter',
};

export default ENTER_KEY_HINTS;
